import React from 'react';
import { Checkbox } from '@framework-controls/core';
import { IconRepairOrder, IconEstimate, IconSuggestedMaint, IconVehInspection, IconMultiPointInspection, IconVCR, IconInvoice, IconPictures, IconHunter } from 'src/content/icons';
import { strings } from 'src/localization';
import * as css from './DocumentTile.module.scss';
import classNames from 'classnames';

interface IProps {
    type: string,
    name: string,
    desc: string,
    updatedDate: string,
    viewed: boolean,
    checked: boolean,
    theme: string,
    onToggle: (id: any, checked: boolean) => void,
    onView: (id: any, checked: boolean) => void,
}

const DocumentTile = (props: IProps) => {
    // set the icon based on document type.
    let icon: JSX.Element | null = null;
    // set the icon and link for each type
    switch (props.type) {
        case 'RO':
            icon = <IconRepairOrder className={css.icon} />;
            break;
        case 'SE':
            icon = <IconEstimate className={css.icon} />;
            break;
        case 'MM':
            icon = <IconSuggestedMaint className={css.icon} />;
            break;
        case 'VI':
            icon = <IconVehInspection className={css.icon} />;
            break;
        case 'RC':
            icon = <IconMultiPointInspection className={css.icon} />;
            break;
        case 'VC':
            icon = <IconVCR className={css.icon} />;
            break;
        case 'IN':
            icon = <IconInvoice className={css.icon} />;
            break;
        case 'IV':
            icon = <IconPictures className={css.icon} />;
            break;
        case 'HU':
            icon = <IconHunter className={css.icon} />;
            break;
        // should the default be something else?
        default:
            icon = null;
            break;
    }

    const tileClasses = classNames(
        css.tile,
        {
            [css.mini]: (props.theme === 'mini'),
        },
        {
            [css.jaguar]: (props.theme === 'jaguar'),
        },
        {
            [css.viewed]: (props.viewed),
        },
        {
            [css.colorSensitive]: (props.theme === 'colorSensitive'),
        },
    );

    // Set the variant style to be used by the checkbox control based on if it
    // is currently checked or not.
    const cbkClassName = props.checked ? 'primaryCkbChecked' : 'primaryCkb';

    return (
        <div className={tileClasses}>
            <div className={css.middleColumn} onClick={() => props.onView(props.type, props.viewed)}>
                {icon}
                <div>
                    <div className={css.documentName}>{props.name}</div>
                    <p className={css.documentDesc}>{props.desc}</p>
                    <p className={css.updated}>{strings.UpdatedColon + props.updatedDate}</p>
                </div>

            </div>
            <div className={css.rightColumn}>
                {props.type !== 'IV' ?
                    <Checkbox
                        id={props.type}
                        // size='rg'
                        variant={cbkClassName}
                        checked={props.checked}
                        onChange={() => props.onToggle(props.type, props.checked)} />:null
                }
            </div>
        </div>
    );
};

export default DocumentTile;